export default __webpack_public_path__ + "static/bed-bath-beyond-7-a-122c58d8e085a512d106e415afdd6319.gif";